export default {"src":"/frontend-static/_next/static/media/americanexpressLight.c5873b36.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};